import { type RefSelectProps } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref, useMemo } from 'react'

import { Select } from '@/components/elements'
import { type SingleOrMultipleSelectProps } from '@/components/types'
import { DESCRIPTIONS } from '@/constants/common/message.constants'
import { type AreaSelectListExEntity } from '@/libs/api'
import { useSelectOnChangeHandler } from '@/libs/hooks'

import { mapToAreaFieldName } from './map-to-area-field-name'

type Props = SingleOrMultipleSelectProps<number, AreaSelectListExEntity> & {
  areas: AreaSelectListExEntity[]
  disabledIds?: number[]
}

/**
 * エリアを選択するSelect
 */
export const AreaSelect = forwardRef(
  (
    {
      className,
      placeholder = DESCRIPTIONS.SELECT,
      areas,
      value,
      mode,
      disabledIds,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const handleChange = useSelectOnChangeHandler({ mode, onChange })
    const options = useMemo(() => {
      return areas?.map((area) => ({
        ...area,
        // nameで指定すると利用側で取得できるoption.nameの値が変わるため、labelで指定
        label: mapToAreaFieldName(area),
        disabled: disabledIds?.includes(area.id)
      }))
    }, [areas, disabledIds])

    return (
      <Select
        customRef={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        optionFilterProp="label"
        fieldNames={{ label: 'label', value: 'id' }}
        className={clsx(['min-w-[280px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
